import { createBrowserHistory, History } from 'history'

let history: History

export const initHistory = () => {
  history = createBrowserHistory({
    basename: '',
    getUserConfirmation: () => {}, // allows native browser prompt to be bypassed for RouterPrompt component
  })
}

const historyRef = {
  instance: () => history,
}

export default historyRef
